import { createSelector, createEntityAdapter } from "@reduxjs/toolkit";
import { apiSlice } from "../../app/api/apiSlice";


const reviewsAdapter = createEntityAdapter({
  sortComparer: (a, b) => new Date(b.createdAt) - new Date(a.createdAt),
});

const initialState = reviewsAdapter.getInitialState();


export const reviewsApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getMyReviews: builder.query({
      query: (user) => `/review/all-my-review?user=${user}`,
      validateStatus: (response, result) => {
        return response.status === 200 && !result.isError;
      },
      transformResponse: (responseData) => {
        const loadedReviews = responseData.map((review) => {
          review.id = review._id;
          return review;
        });
        return reviewsAdapter.setAll(initialState, loadedReviews);
      },
      providesTags: (result, error, arg) => {
        if (result?.ids) {
          return [
            { type: "Review", id: "LIST" },
            ...result.ids.map((id) => ({ type: "Review", id })),
          ];
        } else return [{ type: "Review", id: "LIST" }];
      },
    }),
    getProductReviews: builder.query({
      query: (product) => `/review/for-product?product=${product}`,
    }),

    // getReviewById: builder.query({
    //   query: (id) => `/review/getReviewById?id=${id}`,
    // }),
    // getCartReviews: builder.query({
    //   query: (id) => `/review/myCart?id=${id}`,
    // }),


    // getMyReviews: builder.query({
    //   query: (id) => `/review/myStore?id=${id}`,
    // }),
    addNewReview: builder.mutation({
      query: data => ({
        url: "/review/create",
        method: "POST",
        body: data,
      }),
      invalidatesTags: [
        { type: "Review", id: "LIST" }
      ]
    }),
    updateReview: builder.mutation({
      query: data => ({
        url: "/review/edit",
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: (result, error, arg) => [
        { type: "Review", id: arg.id }
      ]
    }),
    deleteReview: builder.mutation({
      query: ({ id }) => ({
          url: `/review/delete`,
          method: "DELETE",
          body: { id }
      }),
      invalidatesTags: (result, error, arg) => [
          { type: "Review", id: arg.id }
      ]
    }),
  }),
});

export const {
  useGetMyReviewsQuery,
  useGetProductReviewsQuery,
  useAddNewReviewMutation,
  useUpdateReviewMutation,
  useDeleteReviewMutation,
} = reviewsApiSlice